import {$http} from '@/utils/https'
import {
    CHANGE_CATEGORIES_LOADING,
    CHANGE_CATEGORY,
    CHANGE_LIST_ITEM_LOADING,
    CHANGE_LIST_LOADING,
    CHANGE_SKIP,
    SET_CATEGORIES,
    SET_ITEM,
    SET_LIST,
    SET_LIST_LENGTH
} from '../../mutation-types';

import {GET_CATEGORIES, GET_LIST, GET_LIST_ITEM} from '../../action-types';


const state = {
    list: [],
    currentItem: null,
    isListLoading: false,
    isCurrentItemLoading: false,
    skip: 0,
    limit: 9,
    listLength: 0,
    categories: [],
    isLoadingCategories: false,
    activeCategory: ''
};

const getters = {
    categories: state => state.categories,
    isLoadingCategories: state => state.isLoadingCategories,
    activeCategory: state => state.activeCategory,
    list: state => state.list,
    currentItem: state => state.currentItem,
    listLength: state => state.listLength,
    skip: state => state.skip,
    isListLoading: state => state.isListLoading,
    isCurrentItemLoading: state => state.isCurrentItemLoading,
};

const actions = {
    [GET_CATEGORIES]: async ({commit}) => {
        try {
            commit(CHANGE_CATEGORIES_LOADING, true)
            const response = await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}categories`);

            commit(SET_CATEGORIES, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_CATEGORIES_LOADING, false)
        }
    },
    [GET_LIST]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LIST_LOADING, true);
            if (payload.isResetList) {
                commit(SET_LIST, []);
                commit(CHANGE_SKIP, true)
            } else commit(CHANGE_SKIP);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}${payload.educationType}?skip=${state.skip}&limit=${state.limit}&include=picture,category,picture.seo,tariffs,${payload.educationType === 'bonuses' ? 'authors' : 'speakers'}&filters[categories]=${state.activeCategory}`);

            payload.isResetList && commit(SET_LIST, []);
            commit(SET_LIST, response.data.data);
            commit(SET_LIST_LENGTH, response.data.meta.total);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LIST_LOADING, false);
        }
    },
    [GET_LIST_ITEM]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LIST_ITEM_LOADING, true);
            commit(SET_ITEM, null);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}${payload.educationType}/${payload.slug}?include=picture,picture.seo,seo,contents,tariffs,video.chapters,${payload.educationType === 'bonuses' ? 'authors' : 'speakers'},files,video,category&use_as_id=slug`);
            commit(SET_ITEM, null);
            commit(SET_ITEM, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LIST_ITEM_LOADING, false);
        }
    },
};

const mutations = {
    [SET_LIST](state, data) {
        if (!data.length) {
            state.list = data;
        } else {
            data.map(e => {
                if (e.hasOwnProperty('authors')) {
                    e.speakers = e.authors
                }
                return e
            });
        }
        !state.list.length ? state.list = data : state.list.push(...data);
    },
    [SET_LIST_LENGTH](state, length) {
        state.listLength = length;
    },
    [CHANGE_SKIP](state, status = false) {
        if (status) state.skip = 0;
        else state.skip += state.limit;
    },
    [SET_ITEM](state, data) {
        if (data && data.hasOwnProperty('authors')) {
            data.speakers = data.authors
        }
        state.currentItem = data;
    },
    [CHANGE_LIST_LOADING](state, status) {
        state.isListLoading = status;
    },
    [CHANGE_LIST_ITEM_LOADING](state, status) {
        state.isCurrentItemLoading = status;
    },
    [SET_CATEGORIES](state, data) {
        state.categories = data.map(e => {
            return {
                name: e.translation.data.name || '',
                id: e.id
            }
        });
    },
    [CHANGE_CATEGORIES_LOADING](state, status) {
        state.isLoadingCategories = status;
    },
    [CHANGE_CATEGORY](state, category = '') {
        state.activeCategory = category;
        state.skip = 0;
        state.listLength = 0;
        state.list = [];
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
